var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "vks-cs-track" },
    [
      _c(
        "div",
        { ref: "canvasWrap", staticClass: "vks-cs-track-canvas-wrap" },
        [
          _c("canvas", {
            ref: "canvas",
            staticClass: "vks-cs-track-canvas",
            class: {
              "is-pannable": _vm.canPan,
              "is-x-axis-hover": _vm.xAxisBandHover,
              "is-dot-hover": _vm.dotHover,
            },
            on: {
              mousedown: _vm.onMouseDown,
              mousemove: _vm.onMouseMove,
              mouseout: _vm.onMouseOut,
              mouseup: _vm.onMouseUp,
              click: _vm.onCanvasClick,
            },
          }),
          _c("VariantSifterZoomCenterMarker", {
            attrs: {
              "region-view-area": _vm.regionViewArea,
              "region-zoom": _vm.regionZoom,
              "plot-margin": _vm.margin,
              placement: "track",
            },
            on: {
              "update:regionViewArea": function ($event) {
                return _vm.$emit("update:regionViewArea", $event)
              },
            },
          }),
        ],
        1
      ),
      _c("VariantSifterVariantDotMenu", {
        attrs: {
          open: _vm.dotMenuOpen,
          "variant-id": _vm.dotMenuVariantId,
          "is-starred": _vm.dotMenuIsStarred,
          "anchor-x": _vm.dotMenuX,
          "anchor-y": _vm.dotMenuY,
        },
        on: {
          "set-reference": _vm.onDotMenuSetReference,
          "toggle-star": _vm.onDotMenuToggleStar,
        },
      }),
      _c("div", { ref: "tooltip", staticClass: "vks-cs-track-tooltip hidden" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }